import { defineApiResource } from 'api/goodtrust/api/define'

export const DASHBOARD_URL = '/api/v1/user/dashboard'

export const { use: useDashboard } = defineApiResource('/api/v1/user/dashboard', {
  requiresAuth: true,
})
